import type { SelectDropdownProps } from "../../interfaces/componentInterfaces/dropdown";
import "./Dropdown.scss";

const SelectDropdown = ({
  name,
  id,
  options,
  value,
  onChange,
  disabled = false,
}: SelectDropdownProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <select
      name={name}
      id={id}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      className="select"
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default SelectDropdown;

